var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 120,
    viewBox: "0 0 116 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.815 52.5234V107.602C115.815 114.445 110.261 120 103.417 120H12.5498C5.70605 120 0.151367 114.445 0.151367 107.602V52.5234L49.2529 3.60938C54.0811 -1.21875 61.9092 -1.21875 66.7607 3.60938L115.815 52.5234Z",
    fill: "#BBBBBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2524 13.8047H93.854C100.698 13.8047 106.252 19.3594 106.252 26.2031V97.8047C106.252 104.648 100.698 110.203 93.854 110.203H22.2524C15.4087 110.203 9.854 104.648 9.854 97.8047V26.1797C9.854 19.3359 15.4087 13.8047 22.2524 13.8047Z",
    fill: "#F4EEE6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.815 52.5234V107.602C115.815 114.445 110.261 120 103.417 120H12.5498C5.70605 120 0.151367 114.445 0.151367 107.602V52.6875L57.9014 110.438L115.815 52.5234Z",
    fill: "#E1E1E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.229 116.344C110.284 118.312 107.659 119.625 104.752 119.953L12.1274 120C8.86963 119.883 5.9165 118.5 3.76025 116.344L49.229 70.875C54.0571 66.0469 61.9087 66.0469 66.7602 70.875L112.229 116.344Z",
    fill: "#F8F8F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9961 61.1714C69.3999 61.1714 78.6445 51.9268 78.6445 40.5229C78.6445 29.1191 69.3999 19.8745 57.9961 19.8745C46.5923 19.8745 37.3477 29.1191 37.3477 40.5229C37.3477 51.9268 46.5923 61.1714 57.9961 61.1714Z",
    fill: "#00BF00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7847 32.5542L64.2769 39.0464C65.0737 39.8433 65.0737 41.1558 64.2769 41.9761L57.7847 48.4683C56.9878 49.2651 55.6753 49.2651 54.855 48.4683C54.0581 47.6714 54.0581 46.3589 54.855 45.5386L57.8315 42.562H46.3003C45.1519 42.562 44.2378 41.6479 44.2378 40.4995C44.2378 39.3511 45.1519 38.437 46.3003 38.437H57.8315L54.855 35.4604C54.0581 34.6636 54.0581 33.3511 54.855 32.5308C55.6753 31.7573 56.9644 31.7573 57.7847 32.5542ZM63.4331 31.6167H67.6519V49.4292H63.4331C62.2847 49.4292 61.3706 50.3433 61.3706 51.4917C61.3706 52.6401 62.3081 53.5542 63.4331 53.5542H69.7144C70.8628 53.5542 71.7769 52.6401 71.7769 51.4917V29.5542C71.7769 28.4058 70.8394 27.4917 69.7144 27.4917H63.4331C62.2847 27.4917 61.3706 28.4058 61.3706 29.5542C61.3472 30.6792 62.2847 31.6167 63.4331 31.6167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.7105f8a56c20ba69b9a0e6dd6e365856.svg";
export { ForwardRef as ReactComponent };